import { render, staticRenderFns } from "./inflections.vue?vue&type=template&id=6fba2534&"
import script from "./inflections.vue?vue&type=script&lang=js&"
export * from "./inflections.vue?vue&type=script&lang=js&"
import style0 from "./inflections.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\uds\\projects\\alpheios\\components\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6fba2534', component.options)
    } else {
      api.reload('6fba2534', component.options)
    }
    module.hot.accept("./inflections.vue?vue&type=template&id=6fba2534&", function () {
      api.rerender('6fba2534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/inflections.vue"
export default component.exports